import axios from 'axios';

  let base = 'http://admin.spe.cps.com.cn';
  //let base = '/api';

//新趋势
export const trend = params => { return axios.get(`${base}/cateFindOne`, {params:params})};

//新方案
export const scheme = params => { return axios.get(`${base}/cateAll`, {params:params})};

//浏览量
export const pdhits = params => { return axios.get(`${base}/pdhits`, {params:params})};

// 示例
//export const trend = params => { return axios.get(`${base}/cateFindOne`, params).then(res => res.data); };
// export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };


// WEBPACK FOOTER //
// ./src/api/api.js